import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import store from '../../../../redux/store';
import TextareaAutosize from 'react-textarea-autosize';
import { SEND_FEEDBACK } from '../../../../redux/actions/dialogsActions';
import '../../../../assets/styles/custom/components/feedback_popup.scss';
import { Button } from 'antd';

class FeedbackPopup extends PureComponent {
    constructor(props) {
        super(props);

        let score = null;
        let message = '';
        if (props.currentChat.data && props.currentChat.data.feedback) {
            score = props.currentChat.data.feedback.score;
            if (props.currentChat.data.feedback.comments) {
                message = props.currentChat.data.feedback.comments;
            }
        }
        this.state = {
            step: 1,
            score: score,
            feedbackMessage: message,
            messageLength: message.length,
        };

        this.changePoint = this.changePoint.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.prevStep = this.prevStep.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    changePoint(score) {
        this.setState({ score });
    }

    nextStep() {
        if (this.state.score === null) {
            return;
        }
        this.setState({ step: 2 });
    }

    prevStep() {
        this.setState({ step: 1 });
    }

    handleChange(e) {
        let input = e.target.value.trim();
        if (input.length > 400) {
            input = input.split(' ').slice(0, -1).join(' ');
        }

        this.setState({
            feedbackMessage: input,
            messageLength: input.length,
        });
    }

    handleSubmit() {
        const { score, feedbackMessage } = this.state;
        const onSuccess = () => {
            this.props.handleClose();
        };
        store.dispatch({
            type: SEND_FEEDBACK,
            payload: {
                dialog_id: this.props.currentChat.data.id,
                prospect_id: this.props.currentChat.data.prospect.id,
                score: score,
                comments: feedbackMessage,
            },
            onSuccess: onSuccess,
        });
    }

    render() {
        const { step, score, feedbackMessage, messageLength } = this.state;
        const { currentChat } = this.props;

        return (
            <div className="feedback-popup">
                <div>
                    <h2 className="modal-name">Leave your feedback on {currentChat.data.prospect.name}</h2>
                    <div className="step-block-title">
                        <div
                            className={
                                step === 0
                                    ? 'first-step'
                                    : step === 1
                                    ? 'first-step active'
                                    : 'first-step active first-step-finished'
                            }
                        >
                            <span className="register-step-circle" />
                            <span className="step-text">Step 1</span>
                        </div>
                        <div className={step === 2 ? 'steps-line active' : 'steps-line'} />
                        <div className={step === 2 ? 'second-step active' : 'second-step'}>
                            <span className="register-step-circle" />
                            <span className="step-text">Step 2</span>
                        </div>
                    </div>
                </div>
                {step === 1 ? (
                    <div className="first-step-feedback feedback-body-block">
                        <p className="feedback-body-text">
                            How interested is {currentChat.data.prospect.name} in{' '}
                            {currentChat.university ? currentChat.university.name : 'this institution'}?
                        </p>
                        <div className="feedback-scale">
                            <span
                                className={'feedback-score' + (score === 0 ? ' active' : '')}
                                onClick={() => this.changePoint(0)}
                            >
                                0
                            </span>
                            <span
                                className={'feedback-score' + (score === 1 ? ' active' : '')}
                                onClick={() => this.changePoint(1)}
                            >
                                1
                            </span>
                            <span
                                className={'feedback-score' + (score === 2 ? ' active' : '')}
                                onClick={() => this.changePoint(2)}
                            >
                                2
                            </span>
                            <span
                                className={'feedback-score' + (score === 3 ? ' active' : '')}
                                onClick={() => this.changePoint(3)}
                            >
                                3
                            </span>
                            <span
                                className={'feedback-score' + (score === 4 ? ' active' : '')}
                                onClick={() => this.changePoint(4)}
                            >
                                4
                            </span>
                            <span
                                className={'feedback-score' + (score === 5 ? ' active' : '')}
                                onClick={() => this.changePoint(5)}
                            >
                                5
                            </span>
                        </div>
                        <p className="feedback-body-bottom-text">(0 - not interested, 5 - highly interested)</p>
                        <Button onClick={this.nextStep} className="feedback-submit" disabled={score === null}>
                            Next
                        </Button>
                    </div>
                ) : (
                    <div className="second-step-feedback feedback-body-block">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            tabIndex="0"
                            onClick={this.prevStep}
                            width="7.657"
                            height="13.314"
                            viewBox="0 0 7.657 13.314"
                            className="back-from-second-step"
                            aria-label="Back to step 1"
                        >
                            <path
                                id="chevron-left"
                                d="M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"
                                transform="rotate(90 4.071 3.657)"
                            />
                        </svg>
                        <p className="feedback-body-text">
                            Is there anything else you can tell us about {currentChat.data.prospect.name} to help us
                            support them?
                        </p>
                        <div
                            className={
                                'input-feedback-wrapper' +
                                (messageLength >= 380 ? ' input-feedback-wrapper-warning' : '')
                            }
                        >
                            <TextareaAutosize
                                rows={5}
                                maxRows={6}
                                id="feedback-message"
                                type="textarea"
                                placeholder="Type your feedback"
                                defaultValue={feedbackMessage}
                                maxLength={400}
                                className="feedback-input scroll-8"
                                onChange={this.handleChange}
                            />

                            <span
                                className={
                                    'input-length-indicator' +
                                    (messageLength >= 380 ? ' input-length-indicator-warning' : '')
                                }
                            >
                                {`${messageLength}/400`}
                            </span>
                        </div>
                        <Button
                            onClick={this.handleSubmit}
                            className="feedback-submit"
                            disabled={!feedbackMessage.trim().length}
                        >
                            Send
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

export default connect((state) => {
    return {
        account: state.account,
        currentChat: state.currentChat,
    };
})(FeedbackPopup);
